interface JQueryStatic {
    extend<T>(target: T, object1?: T, ...objectN: T[]): T;
    toJSON(obj: any): string;

    /* <CalendarsPicker> */
    calendars: any;
    calendarsPicker: any;
}